import { supabase } from '../supabase/client';
import { getAuthenticatedClient } from '../supabase/authenticatedClient';

export const geocodeAddress = async address => {
  try {
    const response = await fetch(
      `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
        address
      )}&key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}`
    );
    const data = await response.json();

    if (data.status === 'OK' && data.results.length > 0) {
      const location = data.results[0].geometry.location;
      return {
        lat: location.lat,
        lng: location.lng,
      };
    }
    throw new Error('No results found');
  } catch (error) {
    throw new Error('Geocoding failed: ' + error.message);
  }
};

export const getPlaces = async (categoryId = null) => {
  let query = supabase
    .from('places')
    .select(
      `
      *,
      category:categories!category_id (
        name,
        icon_name
      ),
      categories (
        id,
        name,
        icon_name
      ),
      cities (
        name,
        state,
        lat,
        lon
      )
    `
    )
    .order('name')
    .neq('status', 'submitted')
    .neq('status', 'inactive')
    .neq('status', 'disabled');

  if (categoryId) {
    query = query.or(`category_id.eq.${categoryId},categories.id.eq.${categoryId}`);
  }

  const { data, error } = await query;

  if (error) {
    throw error;
  }

  return data;
};

export const allPlaces = async () => {
  const { data, error } = await supabase
    .from('places')
    .select(
      `
      *,
      category:categories!category_id (
        name,
        icon_name
      ),
      cities (
        name,
        state
      )
    `
    )
    .order('name');

  if (error) {
    throw error;
  }

  return data;
};

export const createPlace = async placeData => {
  const client = await getAuthenticatedClient();
  const { data, error } = await client.from('places').insert([placeData]).select().single();

  if (error) {
    throw error;
  }

  return data;
};

export const updatePlace = async (id, placeData) => {
  const client = await getAuthenticatedClient();
  const { data, error } = await client
    .from('places')
    .upsert({ ...placeData, id })
    .select()
    .single();

  if (error) {
    throw error;
  }

  return data;
};

export const deletePlace = async id => {
  const client = await getAuthenticatedClient();
  const { error } = await client.from('places').delete().eq('id', id);

  if (error) {
    throw error;
  }
};
